'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _enforceArity2 = require('./internal/_enforceArity');

var _enforceArity3 = _interopRequireDefault(_enforceArity2);

var _enforceFunction2 = require('./internal/_enforceFunction');

var _enforceFunction3 = _interopRequireDefault(_enforceFunction2);

var _setArity2 = require('./internal/_setArity');

var _setArity3 = _interopRequireDefault(_setArity2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint no-use-before-define: 0 */
function bindWithArity(operation, arity, args) {
  var curried = (0, _setArity3.default)(arity, curryInternal.bind(null, operation, arity, args));
  curried.args = args;
  curried.operation = operation;
  return curried;
}

function curryInternal(operation, arity, prevArgs) {
  for (var _len = arguments.length, nextArgs = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    nextArgs[_key - 3] = arguments[_key];
  }

  var remainingArity = arity - nextArgs.length;
  var args = prevArgs.concat(nextArgs);
  if (remainingArity <= 0) {
    return operation.apply(undefined, _toConsumableArray(args));
  }
  return bindWithArity(operation, remainingArity, args);
}

function curryN(arity, operation) {
  return bindWithArity((0, _enforceFunction3.default)(operation), (0, _enforceArity3.default)(arity), []);
}

/**
 * Create a curried version of `operation` that expects `arity` arguments.
 * Inception-ally, `curryN` is also curried.
 *
 * @example
 * const toArray = curryN(3)((...args) => [...args]);
 * toArray(1, 2, 3) === [1, 2, 3];
 *
 * @param  {number} arity number of arguments the curried function accepts
 * @param  {Function} operation to curry
 * @return {Function}
 */
exports.default = curryN(2, curryN);
module.exports = exports['default'];